import React, { useState, useContext } from 'react';
import { NavContext } from 'providers/NavProvider';
import useUser from 'hooks/useUser';

import SideBar from './SideBar';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import useZoomScale from 'hooks/useZoomScale';

import useStyles from './styles';

const defaultFontSize = 30;

function NavBar() {
  const [open, setOpen] = useState(false);
  const { title, rightButton } = useContext(NavContext)
  const styles = useStyles();
  const { user } = useUser();
  const scale = Math.min(useZoomScale(), 1);

  const toggleDrawer = () => {
    setOpen(!open);
  }

  return (
    <AppBar position="static">
      <Toolbar>
        {user && 
          <IconButton 
            edge="start" 
            className={styles.menuButton} 
            color="inherit" 
            aria-label="menu" 
            onClick={toggleDrawer}
          >
            <MenuIcon style={{ fontSize: defaultFontSize / scale }} />
          </IconButton>
        }
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>
        {!!rightButton && <Button color="inherit">Login</Button>}
      </Toolbar>
      <SideBar open={open} toggleDrawer={toggleDrawer} />
    </AppBar>
  )
}

export default NavBar